<div
  class="fixed inset-0 z-[800] flex justify-center bg-black/40"
  [ngClass]="centered() ? 'items-center p-6' : 'items-end lg:items-center lg:p-6'"
  (click)="dismiss()"
>
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="catalog-filters-title"
    class="flex max-h-[85vh] w-full flex-col bg-white shadow-xl"
    [ngClass]="centered() ? 'max-w-2xl rounded-3xl' : 'rounded-t-3xl lg:max-w-2xl lg:rounded-3xl'"
    (click)="$event.stopPropagation()"
  >
    <header class="flex items-center justify-between gap-4 px-5 pb-2 pt-5">
      <h2
        id="catalog-filters-title"
        class="font-base text-xl font-bold"
      >
        {{ 'catalog-filters.title' | translate }}
      </h2>
      <button
        type="button"
        class="icon icon-cross flex h-10 w-10 items-center justify-center rounded-full bg-neutral-100 text-neutral-800"
        [attr.aria-label]="'catalog-filters.close' | translate"
        (click)="dismiss()"
      ></button>
    </header>

    <div class="overflow-y-auto px-5 py-2">
      @if (options().exclude.length) {
        <section class="py-3">
          <h3 class="font-base text-base font-bold">
            {{ 'catalog-filters.without-section' | translate }}
          </h3>
          <p class="mb-4 text-sm text-neutral-600">
            {{ 'catalog-filters.without-hint' | translate }}
          </p>
          <ng-container
            [ngTemplateOutlet]="filterChips"
            [ngTemplateOutletContext]="{ $implicit: options().exclude }"
          />
        </section>
      }

      @if (options().require.length) {
        <section class="pb-4 pt-8">
          <h3 class="font-base text-base font-bold">
            {{ 'catalog-filters.only-section' | translate }}
          </h3>
          <p class="mb-4 text-sm text-neutral-600">
            {{ 'catalog-filters.only-hint' | translate }}
          </p>
          <ng-container
            [ngTemplateOutlet]="filterChips"
            [ngTemplateOutletContext]="{ $implicit: options().require }"
          />
        </section>
      }
    </div>

    <footer
      class="mt-4 flex items-center justify-between gap-4 border-t border-neutral-200 px-5 py-4"
    >
      <button
        type="button"
        class="font-base text-sm underline"
        (click)="clearDraft()"
      >
        {{ 'filters.delete-all' | translate }}
      </button>
      <app-button-atom
        type="primary"
        size="L"
        [label]="'catalog-filters.see-products' | translate: { count: visibleCount() }"
        (clickEventEmitter)="apply()"
      ></app-button-atom>
    </footer>
  </div>
</div>

<ng-template
  #filterChips
  let-filters
>
  <ul class="flex flex-wrap gap-2">
    @for (option of filters; track optionKey(option)) {
      <li>
        <button
          type="button"
          class="inline-flex items-center gap-1.5 rounded-full border px-4 py-2 font-base text-sm"
          [class.border-neutral-900]="isSelected(option)"
          [class.bg-neutral-900]="isSelected(option)"
          [class.text-white]="isSelected(option)"
          [class.border-neutral-300]="!isSelected(option)"
          [class.bg-white]="!isSelected(option)"
          [class.text-neutral-800]="!isSelected(option)"
          [attr.aria-pressed]="isSelected(option)"
          (click)="toggle(option)"
        >
          @if (isSelected(option)) {
            <i
              class="icon icon-check-plain text-xs"
              aria-hidden="true"
            ></i>
          }
          <span>
            {{
              option.kind === 'allergen' ? ('allergens.' + option.name | translate) : option.name
            }}
          </span>
        </button>
      </li>
    }
  </ul>
</ng-template>
